export default function (node) {
    return node.getAttribute('aria-label');
}
